export const DeLocale = {
    page: {
        txtTitle: 'UNVOX | Gesang sofort entfernen',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'unvox Logo',
        },
        action: {
            txtBack: 'Zurück',
            txtRetry: 'Erneut versuchen',
            txtStartOver: 'Neu starten',
        },
        job: {
            txtCheckingStatus: 'Job-Status wird geprüft',
            txtIdLabel: 'Job-ID',
        },
        footer: {
            linkPrivacyPolicy: 'Datenschutz',
            linkTerms: 'Bedingungen',
            linkRefunds: 'Rückerstattungen',
            linkSupport: 'Support',
            txtAllRightsReserved: 'Alle Rechte vorbehalten.',
            txtBugReportsAndFeatures: 'Fehlerberichte und Funktionsanfragen',
        },
        share: {
            title: 'UNVOX | Song-Gesang mit einem Klick entfernen',
            text: 'Verwandle deine Lieblingssongs ganz einfach in karaokefertige Instrumentals!',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Gesang mit einem Klick entfernen',
            txtHeroSubtitle: 'Sofortige Instrumentals aus deinem Track oder direkt von YouTube',
            txtInputTypeLabel: 'Eingabetyp',
            txtInputTypeFile: 'Audiodatei hochladen',
            txtInputTypeYoutube: 'YouTube-Link',
            txtInputFilePick: 'Datei auswählen',
            txtInputFileSub: 'Gängige Audioformate ({{formats}}), bis {{size}} MB.',
            txtPreviewAction: 'Gesang entfernen',
            txtPreviewFailed: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
            txtUploadSelectFile: 'Noch keine Datei ausgewählt',
            txtYoutubeLabel: 'YouTube-URL',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Füge einen öffentlichen YouTube-Link ein.',
            txtYoutubeMissing: 'Bitte füge eine YouTube-URL ein.',
            txtYoutubeInvalid: 'Gib eine gültige YouTube-URL ein.',
            txtYoutubeTooLong: 'Dieses Video ist länger als 15 Minuten. Bitte wähle ein kürzeres Video.',
            txtCheckoutUploadFailed: 'Upload fehlgeschlagen. Bitte erneut versuchen.',
            txtUploadMissing: 'Bitte wähle vor dem Upload eine Datei aus.',
            txtFileTypeInvalid: 'Nicht unterstützter Dateityp. Bitte lade eine Audiodatei hoch (z. B. {{formats}}).',
            txtFileTooLarge: 'Datei ist zu groß. Maximale Größe: {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Vorschau konnte nicht erstellt werden',
            txtUnavailableBody: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
            txtPreparingTitle: 'Vorschau wird vorbereitet',
            txtPreparingBody: 'Das kann bis zu 2 Minuten dauern',
        },
        payment: {
            txtUnavailableTitle: 'Vorschau konnte nicht erstellt werden',
            txtUnavailableBody: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuche es später erneut.',
            txtPreparingTitle: 'Vorschau wird vorbereitet',
            txtCheckoutCancelledBody: 'Es wurde nichts berechnet. Du kannst es jederzeit erneut versuchen.',
            txtTrackPreviewLabel: 'Track-Vorschau',
            txtTrackPreviewHelper: 'Diese Vorschau ist ein 15-Sekunden-Ausschnitt deines Tracks zur Bewertung',
            txtEmailLabel: 'E-Mail-Adresse',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'Wir verwenden diese Adresse, um dir deinen Download-Link zu senden.',
            txtCheckoutAction: 'Gesang entfernen für nur {{price}}',
            txtCheckoutActionFallback: 'Gesang entfernen',
            txtCheckoutFailed: 'Checkout konnte nicht gestartet werden. Bitte erneut versuchen.',
            txtInvalidEmail: 'Gib eine gültige E-Mail-Adresse ein.',
        },
        processing: {
            txtMissingTitle: 'Job-ID fehlt',
            txtMissingBody: 'Diese Seite benötigt eine Job-ID. Bitte starte eine neue Vorschau.',
            txtMissingAction: 'Zurück zum Upload',
            txtStatusFailed: 'Job-Status konnte nicht abgerufen werden. Bitte erneut versuchen.',
            txtErrorTitle: 'Etwas ist schiefgelaufen',
            txtSupportAction: 'Support kontaktieren',
            txtConfirmingTitle: 'Zahlung wird bestätigt',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Nach Updates wird gesucht',
            txtWorkingTitle: 'Dein kompletter Track wird verarbeitet',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Weiteren starten',
            txtReadyTitle: 'Download bereit',
            txtReadyBody: 'Dein Instrumental ist bereit zum Download.',
            txtDownloadAction: 'Herunterladen',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Weiteren starten',
        },
        invalidJob: {
            txtTitle: 'Ungültige Job-ID',
            txtBody: 'Dieser Job wurde nicht gefunden. Bitte starte einen neuen Upload.',
            txtAction: 'Neu starten',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Support',
            txtTitle: 'Support kontaktieren',
            txtLastUpdatedLabel: 'Zuletzt aktualisiert',
            txtLastUpdatedDate: '9. Februar 2026',
            txtSectionEmailTitle: 'E-Mail',
            txtSectionEmailBodyPrefix: 'Schreib uns an',
            txtSectionIncludeJobIdTitle: 'Füge deine Job-ID hinzu',
            txtSectionIncludeJobIdBody: 'Bitte füge deine Job-ID hinzu, damit wir deinen Job schnell finden. Wenn du bezahlt hast, füge auch die beim Checkout verwendete E-Mail-Adresse hinzu.',
            txtSectionBugReportsTitle: 'Fehlerberichte',
            txtSectionBugReportsBody: 'Du kannst Fehlerberichte und Funktionsanfragen auch über den Link im Footer senden.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Feedback',
            txtTitle: 'Fehlerberichte und Funktionsanfragen',
            txtSubtitle: 'UNVOX ist noch früh. Wenn sich etwas falsch anfühlt oder du eine Idee hast, schick sie uns. Klare Berichte sind der schnellste Weg zu Fixes.',
            txtWhatToIncludeTitle: 'Was enthalten sein sollte',
            txtChecklistExpectedVsActual: 'Was du erwartet hast vs. was passiert ist',
            txtChecklistSteps: 'Schritte zum Reproduzieren (1, 2, 3)',
            txtChecklistBrowserOs: 'Dein Browser und Betriebssystem',
            txtChecklistJobId: 'Job-ID (falls ein Upload beteiligt war)',
            txtTipTitle: 'Tipp',
            txtTipBody: 'Wenn du uns eine E-Mail schreibst, kannst du direkt auf die Liefer-E-Mail antworten und die Vorlage einfügen.',
            txtTemplateTitle: 'Copy-Paste-Vorlage',
            txtTemplateBody: 'Fehlerbericht / Funktionsanfrage\n\nTyp: bug | feature\nZusammenfassung:\n\nDetails:\n- Was ist passiert:\n- Was hast du erwartet:\n- Schritte zum Reproduzieren:\n  1.\n- Browser/OS:\n\nOptional:\n- Job-ID:\n- YouTube-URL:\n- Screenshot/Video:\n',
            txtTemplatePageLabel: 'Seite',
            txtTemplateUserAgentLabel: 'User Agent',
            txtCopyActionIdle: 'Vorlage kopieren',
            txtCopyActionCopied: 'Kopiert',
            txtCopyActionFailed: 'Kopieren fehlgeschlagen',
            txtCopyHelpFailed: 'Der Zugriff auf die Zwischenablage wurde blockiert. Du kannst den Text oben trotzdem markieren und manuell kopieren.',
            txtCopyHelpIdle: 'Nichts hier wird automatisch gesendet. Diese Seite hilft dir nur, einen guten Bericht zu formatieren.',
        },
    },
};
